import { Component } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { LoaderService } from './loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent{
  title = 'contech-media-movie-dashboard';

  constructor(private router: Router, private loaderService: LoaderService ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loaderService.show();
        console.log('show')
      } else if (event instanceof NavigationEnd) {
         window.scrollTo(0, 0);
          this.loaderService.hide();
      }
    });
  }
  
  }

